export default {
  // $LocalH5('nextStep.getHandlerTips')
  toolbar:{
    urgingMessage:'催办消息',
    msgType:'消息类型',
    processTrack:'流程轨迹',
    processTrackTips:'获取流程轨迹失败！',
    goBack:'退回',
    goBackTo:'退回至',
    handledBy:'办理人',
    toUserGroup:'转给用户组',
    toPersonnel:'转给人员',
    addHandler:'加签',
    removeHandler:'减签',
    node:'节点',
    handler:'处理人',
    handlerGroup:'处理组',
    userGroupTips:'获取用户组失败',
    selectNode:'请选择节点',
    noChangeTips:'节点下处理人/组无变更',
    urgingContentTips:'请输入催办内容',
    urgingContentSize:'催办内容不超过500个字符',
    urgingMethodTips:'请至少选择一种催办方式',
    urgedSuccess:'催办成功',
    urgingFailed:'催办失败',
    addSuccess:'加签成功',
    failedAdd:'加签失败',
    removeSuccess:'减签成功',
    failedRemove:'减签失败',
    actionSuccess:'{action}成功',
    actionFailed:'{action}失败'
  },
  nextStep:{
    selectPlaceholder:'请选择',
    getHandlerTips:'处理人获取中,请稍等',
    currentNode:'当前节点',
    cur_node_desc:'当前节点描述',
    nextStep:'下一步',
    node_desc:'下一步说明',
    assignee:'下一步办理人',
    addAssignee:'添加办理人',
    assigneeGroup:'下一步办理组',
    circulator:'被传阅人',
    nodeMsg:'请选择下一步节点',
    assigneeMsg:'请选择下一步办理人',
    nodeEmptyMsg:'请先选择下一步节点',
    addAssigneer: '添加处理人',
    addAssigneeMsg: '请选择添加处理人',
  },
  pageView:{
    msgType: '消息类型',
    validCodeMsg: '请至少选择一个发送方式',
  },
  sealOrSign:{
    addSeal:'添加印章',
    addSignature:'添加签名',
    viewOther:'查看其它意见',
    chooseSeal:'印章选择',
    chooseSign:'签名选择',
    userDirections:'使用说明',
    text1:'打开手机扫一扫二维码，在手机端创建签名',
    text3:'勾选“电子签名”',
    remark:'备注',
    text4:'创建完的电子签名，下次可直接使用，勾选“电子签名”即可',
    click:'点击',
    text2:'按钮，加载（刷新）签名图片',
    text5:'打开手机扫一扫，创建签名',
    text6:'二维码失效，请点击',
    refresh:'刷新',
    electSign:'电子签名',
    secondVerrifi:'二次认证',
    phone: '手机号',
    sendCode: '验证码',
    getValidCode: '获取验证码',
    inputEnter: '请输入...',
    validPhone:'请输入手机号',
    validPhoneMsg:'无效的手机号',
    validCode:'请输入验证码',
    validCodeMsg:'验证码获取失败!',
    validFail:'校验失败!',
    countdown:'获取中({key})',
    validSeal:'请选择电子印章',
    validSign:'请选择电子签名',
    validSealAndSign:'请选择电子印章与签名',
  },
  suggestion: '意见',
  saveComment: '保存为常用意见',
  commonComment: '常用意见',
  vaildComment:'请输入意见内容',
  validCommentRequired:'审批意见选项必选',
 
  recipient: '收件人',
  chooseRecipient:'请选择收件人',
  distributeInstru:'分发说明',
  validDistriInstru:'请输入分发说明',
  createTime: '创建时间',
  creator: '创建人',
  operateSuccess: '操作成功', // 请求成功
  operateFail: '操作失败', // 请求成功
  noPerminss: '暂无权限',
  interfaceError: '接口异常!',
  buttonCancel: '取消',
  buttonConfirm: '确定',
  noData: '暂无数据', // 没有数据

  search: '搜索',
  searchPlaceholder: '请输入姓名/职工号',
  selectMember:'选择人员',
  validSeleMember: '请选择人员',
  organization:'组织机构',
  waitPersonnel:'待选人员',
  selectedPersonnel:'已选人员',
  name:'姓名',
  numId:'工号',
  org:'组织机构',
  delete:'删除',
  change:'更改',

  title:'标题',
  content:'内容',
  requestFailed:'Api请求失败'
}
